
import { SOUND_FREQUENCIES } from './constants.js';

class AudioService {
  constructor() {
    this.context = null;
  }

  init() {
    if (!this.context) {
      this.context = new (window.AudioContext || window.webkitAudioContext)();
    }
    if (this.context.state === 'suspended') {
      this.context.resume();
    }
  }

  playTone(freq, type = 'sine', duration = 0.1) {
    this.init();
    if (!this.context) return;

    const osc = this.context.createOscillator();
    const gain = this.context.createGain();

    osc.type = type;
    osc.frequency.setValueAtTime(freq, this.context.currentTime);

    gain.gain.setValueAtTime(0.1, this.context.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.01, this.context.currentTime + duration);

    osc.connect(gain);
    gain.connect(this.context.destination);

    osc.start();
    osc.stop(this.context.currentTime + duration);
  }

  playSelect() {
    this.playTone(SOUND_FREQUENCIES.SELECT, 'sine', 0.05);
  }

  playMatch() {
    this.playTone(SOUND_FREQUENCIES.MATCH, 'triangle', 0.15);
  }

  playFail() {
    this.playTone(SOUND_FREQUENCIES.FAIL, 'sawtooth', 0.2);
  }

  playLevelUp() {
    this.playTone(SOUND_FREQUENCIES.LEVEL_UP, 'sine', 0.4);
    setTimeout(() => {
      this.playTone(SOUND_FREQUENCIES.LEVEL_UP * 1.5, 'sine', 0.4);
    }, 100);
  }
}


export const audioService = new AudioService();
